













import { Component } from 'vue-property-decorator';
import HasSideDrawerMixin from '@/mixin/Layout/has-side-drawer-mixin';
import SideBar from '@/components/ViewComponent/Attendance/SideBar.vue';

@Component<Attendance>({
  components: { SideBar },
})
export default class Attendance extends HasSideDrawerMixin {}
